import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';

const NameEditorWrapper = styled('form')(
  {
    display: 'flex',
    alignItems: 'center',
    input: {
      marginRight: 6,
      color: 'inherit',
      width: 256,
      fontWeight: 500,
      '::placeholder': {
        color: 'inherit',
      },
    },
    '.MuiIconButton-root': {
      marginRight: '0 !important',
      opacity: '1 !important',
      ':disabled': {
        opacity: '0.3 !important',
      },
    },
  },
  addHighContrastStyles(({ theme }) => ({
    input: {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
    },
  })),
);

export default NameEditorWrapper;
